import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import api from "./http";
import i18n from "./i18n";
import store from "./store";
import "@/utils/directives"; // 弹框拖拽指令
import "@/utils/drag"; // 拖拽指令
import "@/utils/inputFilter"; // 限制输入框输入指令
import global from "@/utils/global";
import TIPSINFO from "@/utils/tipsInfo";
import toolutil from "@/utils/toolutil";
import rules from "@/utils/rules";
import { xyjTaskQueue } from "@/utils/xyjTaskQueue";
import ElementUI from "element-ui";
import XyjTable from "@/components/xyjtable/xyjTable";
import XyjTableDrag from "@/components/xyjtable/xyjtableDrag";
// import menuRoute from "@/components/xyjMenuRouteDialog/xyjMenuRouteDialog";
import XyjRemoteTable from "@/components/xyjtable/xyjAnotherTable";
import XyjTableWorkFlow from "@/components/xyjtable/xyjTableWorkFlow";
import xyjWorkflowDialog from "@/components/xyjworkflowDialog/xyjworkflowDialog";
import BranchPostDialog from "@/components/BranchPostDialog/BranchPostDialog";
import xyjpostDialog from "@/components/xyjpostDialog/xyjpostDialog";
import xyjdeptDialog from "@/components/xyjdeptDialog/xyjdeptDialog";
import xyjdictDialog from "@/components/xyjdictDialog/xyjdictDialog";
import xyjMenuRouteDialog from "@/components/xyjMenuRouteDialog/xyjMenuRouteDialog";
import branchdeptDialog from "@/components/branchDept/BranchDept";
import FaIconTooltip from "@/components/FaIconTooltip";
import "element-ui/lib/theme-chalk/index.css";
import "font-awesome/css/font-awesome.min.css";
// import "@/assets/iconfont/iconfont.css";
import "@/assets/iconfont2/iconfont.css";
import XyjButton from "@/components/XyjButton/XyjButton"; // 按钮
import XyjUpload from "@/components/XyjUpload/XyjUpload"; // 上传组件
import WorkFlowClient from "@/components/WorkFlow/WorkFlowClient"; // 审批组件
import newWorkFlowClient from "@/components/WorkFlow/newWorkFlowClient"; // 最新的审批组件
import map from "@/components/bcomponents/map.js"; // 地图
// import citydata from "@/assets/provinceAndCityData/citydata3.js"; // 省市区组件
import Echarts from "echarts"; // echarts图表
import "echarts/lib/chart/line";
import "echarts/map/js/china";
import "echarts/map/js/world";
import "echarts/map/js/province/henan";
// import upload from "@/views/upload/upload"; // 上传文件
import download from "@/views/upload/download";// 下载模板组件
import FormMaking from "@/components/vueformmaking/index.js";// 拖拽
import editor from "@/components/bcomponents/tinymceEditor";// 富文本
import treeTransfer from "el-tree-transfer";// 树形穿梭框
import DynamicLink from "@/components/vueformmaking/DynamicLink"; // 远程加载组件
import mailTable from "@/components/tableComponent/TableComponent"; // 左边表头右边数据的表格
import previewTopology from "@/components/topologycomponent/previewTopology";// 拓扑图预览
Vue.use(FormMaking);
import Mqtt from "@/mqtt/mqtt";// mqt
import topic from "@/mqtt/topics";// mqtt主题
import Container from "@/components/vueformmaking/Container"; // 拖拽组件
import XyjVueLoader from "../static/XyjVueLoader.js";// 解析vue文件
import province from "../static/cityData.js";// 省市区
import areaCity from "../static/areaCity.js";// 省市
import axios from "@/http/axios";// 封装的axios请求
import Cookies from "js-cookie";// cookies
import jquery from "jquery";// jquery
import BScroll from "better-scroll";// 滚动条插件
import Clipboard from "clipboard";// 复制粘贴插件
import { CaseOnly } from "@/mixin/CaseOnlyMixin";// 混入
import { Button, DatetimePicker, Area, NumberKeyboard, PasswordInput, Popup, Dialog, RadioGroup, Radio, Swipe, SwipeItem, SwipeCell, ImagePreview, Circle, Picker, IndexBar, IndexAnchor } from "vant";
import "vant/lib/index.css";
import area from "@/utils/area";// 带编号的省市组件
import VueLocalForage from "vue-localforage";// 存储
import JSZip from "jszip";// 创建、读取和编辑.zip文件的JavaScript库
import FileSaver from "file-saver";// 文件导出插件，与上边的jszip一块使用实现打包文件并下载
import * as faceapi from "face-api.js"; // 人脸识别face-api
window.faceapi = faceapi;
import Viewer from "v-viewer"; // 图片预览
import "viewerjs/dist/viewer.css";
import dplayer from "./components/dplayer/dplayer.vue";// 视频插件
import Recorder from "recorder-core/recorder.mp3.min";// h5录音
import "recorder-core/src/extensions/waveview";// 录音时可以绘制音波 https://github.com/xiangyuecn/Recorder
Vue.prototype.Recorder = Recorder; // h5录音
import flvjs from "flv.js";
import hlsjs from "hls.js";
import { UPLOADFILEOSS } from '@/utils/utils.js'
// 瀑布组件
import { Waterfall } from "vue-waterfall-plugin";
import "vue-waterfall-plugin/dist/style.css";
// 拖拽组件
import Draggable from 'vuedraggable'

import AMapLoader from '@amap/amap-jsapi-loader'

// production   development  生产环境去除console.log打印
if (process.env.NODE_ENV === 'production') {
  console.log = () => { }
}

window.flvjs = flvjs;
window.hlsjs = hlsjs;
Vue.component("dplayer", dplayer);
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});
Vue.use(VueLocalForage);
Vue.use(Button)
  .use(DatetimePicker)
  .use(Popup)
  .use(Dialog)
  .use(RadioGroup)
  .use(Radio)
  .use(Swipe)
  .use(SwipeItem)
  .use(ImagePreview)
  .use(PasswordInput)
  .use(NumberKeyboard)
  .use(Area)
  .use(SwipeCell)
  .use(Circle)
  .use(Picker)
  .use(IndexBar)
  .use(IndexAnchor);
/*
* 王伟东 2020-4-1 11:59:17
* 描述：滚动插件
* 版本： 1.0
* */
Vue.prototype.$BScroll = BScroll;
/*
* 王伟东 2020-3-28 14:37:44
* 描述：省市区文件
* 版本： 1.0
* */
Vue.prototype.$areaData = area;
// 消息队列
Vue.prototype.$TaskQueue = xyjTaskQueue;
/**
 *宋建国：2020/3/20 10:41
 *描述：为组件混入通用代码
 *版本：1.0
 */
import authority from "@/components/appComponents/authorityControl.vue";
import xyjUserDialog from "@/components/xyjUserDialog/xyjUserDialog"; // 选择员工弹框
// 权限控制组件
Vue.component("authority", authority);
Vue.mixin(CaseOnly);
Vue.use(ElementUI);
Vue.use(api);
Vue.component("XyjTable", XyjTable);
Vue.component("XyjTableDrag", XyjTableDrag);
Vue.component("XyjRemoteTable", XyjRemoteTable);
Vue.component("treeTransfer", treeTransfer);
Vue.component("XyjTableWorkFlow", XyjTableWorkFlow);
Vue.component("XyjButton", XyjButton);
Vue.component("XyjUpload", XyjUpload);
Vue.component("editor", editor);
Vue.component("WorkFlowClient", WorkFlowClient); // 工作流客户端
Vue.component("newWorkFlowClient", newWorkFlowClient); // 工作流客户端
// Vue.component("upload", upload);// 导入模板
Vue.component("download", download);// 下载模板
Vue.component("DynamicLink", DynamicLink);// 生产运行时，动态加载组件
Vue.component("mailTable", mailTable);
Vue.component("previewTopology", previewTopology);
Vue.component("xyjWorkflowDialog", xyjWorkflowDialog);
Vue.component("xyjUserDialog", xyjUserDialog);
Vue.component("BranchPostDialog", BranchPostDialog);
Vue.component("xyjpostDialog", xyjpostDialog);
Vue.component("xyjdeptDialog", xyjdeptDialog);
Vue.component("xyjdictDialog", xyjdictDialog);
Vue.component("xyjMenuRouteDialog", xyjMenuRouteDialog);
Vue.component("FaIconTooltip", FaIconTooltip);
Vue.component("branchdeptDialog", branchdeptDialog);
Vue.component("Container", Container);
Vue.component('Waterfall', Waterfall);
Vue.component('Draggable',Draggable)

Vue.prototype.map = map;
// Vue.prototype.citydata = citydata;
Vue.prototype.global = global;
Vue.prototype.$echarts = Echarts;
Vue.prototype.$TINFO = TIPSINFO;
Vue.prototype.$tu = toolutil;
Vue.prototype.$rule = rules;
Vue.prototype.axios = axios;
Vue.prototype.Cookies = Cookies;
Vue.prototype.jquery = jquery;
Vue.prototype.province = province;
Vue.prototype.areaCity = areaCity;
Vue.prototype.Clipboard = Clipboard;
Vue.prototype.JSZip = JSZip;
Vue.prototype.FileSaver = FileSaver;
Vue.prototype.$UPLOADFILEOSS = UPLOADFILEOSS;
Vue.prototype.$AMapLoader = AMapLoader;

/*
* 王伟东 2020-3-27 18:26:17
* 描述：让地理导航组件显示,并接受要导航的地理位置信息
* 版本：1.0
* */
Vue.prototype.showLocation = function(params) {
  const info = {
    key: "local",
    value: {}
  };
  if (this.$tu.isBlank(params)) {
    this.$store.commit("setApplicationData", info);
  } else if (typeof params !== "object") {
    this.$store.commit("setApplicationData", info);
  } else {
    info.value = params;
    this.$store.commit("setApplicationData", info);
  }
  this.jquery(".MARKUP-XYJ").addClass("showMarkupXYJ");
  this.jquery(".map-link-box").addClass("groupFloat");
};

/*
* 王伟东 2020-3-27 18:26:17
* 描述：让地理导航组件隐藏
* 版本：1.0
* */
Vue.prototype.hideLocation = function() {
  this.$store.commit("setApplicationData", { local: {} });
  this.jquery(".MARKUP-XYJ").removeClass("showMarkupXYJ");
  this.jquery(".map-link-box").removeClass("groupFloat");
};
/*
* 王伟东 2020-3-28 18:26:17
* 描述：显示遮罩
* 版本：1.0
* */
Vue.prototype.showMarkup = function() {
  this.jquery(".MARKUP-XYJ").addClass("showMarkupXYJ");
};
/*
* 王伟东 2020-3-28 18:26:17
* 描述：隐藏遮罩
* 版本：1.0
* */
Vue.prototype.hideMarkup = function() {
  this.jquery(".MARKUP-XYJ").removeClass("showMarkupXYJ");
};
/**
 *宋建国：2020/1/3 15:41
 *描述：远程加载功能
 *版本：1.0
 */
Vue.prototype.$XyjVueLoader = XyjVueLoader;
/**
 *宋建国：2019/11/28 16:58
 *描述：消息通行自定义主题协议
 *版本：1.0
 */
Vue.prototype.$topic = topic;
/**
 * @description
 * @author (Set the text for this tag by adding docthis.authorName to your settings file.)
 * @date 2020-10-19
 * @param { number } type 1 localStorage 2 sessionStorage
 * @param { string } key 键
 * @param { string } data 要存储的数据
 * @returns
 */
Vue.prototype.$addStorageEvent = function(type, key, data) {
  if (type === 1) {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function(k, val) {
        localStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent("setItem", false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, data);
  } else {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function(k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent("setItem", false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, data);
  }
};
Vue.prototype.$bus = new Vue(); // event Bus 用于无关系组件间的通信。
const tmpmqtt = new Mqtt.CreateMqtt(global.websocket.hostIp, global.websocket.Port);
Vue.prototype.$mqtt = tmpmqtt;
window.$mqtt = tmpmqtt;
// 日期格式化
// {
//   '年-月-日 时：分：秒': new Date().format("yyyy-MM-dd hh:mm:ss") ,
//   '年-月-日': new Date().format("yyyy-MM-dd") ,
//   '（指定日期）年-月-日': new Date(new Date(time)).getTime()).format("yyyy-MM-dd") ,
// }
Date.prototype.format = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1,                 // 月份
    "d+": this.getDate(),                    // 日
    "h+": this.getHours(),                   // 小时
    "m+": this.getMinutes(),                 // 分
    "s+": this.getSeconds(),                 // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    "S": this.getMilliseconds()             // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
};
window.xyjVue = new Vue({
  el: "#app",
  i18n,
  router,
  store,
  render: h => h(App)
});


window._AMapSecurityConfig = {
  securityJsCode: "4e5aea4b4f65366b5382ba12dc8b64f3"
};



// WEBPACK FOOTER //
// ./src/main.js